import { render } from "./RecuperarPassword.vue?vue&type=template&id=03c47938&scoped=true"
import script from "./RecuperarPassword.vue?vue&type=script&lang=js"
export * from "./RecuperarPassword.vue?vue&type=script&lang=js"

import "./RecuperarPassword.vue?vue&type=style&index=0&id=03c47938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c47938"]])

export default __exports__